import { useDataSource } from '@/src/renderer/lib/dataSource'
import type { HabitLog } from '@/src/renderer/lib/db/models'

/**
 * Reactive completion logs for a set of habits, grouped by habitId.
 *
 * Returns a `Map<habitId, HabitLog[]>` (empty array for habits with no logs).
 * Re-subscribes when the set of habit ids changes. Used to derive both the
 * selected day's checkbox state and the streak (which needs the full history).
 *
 * Returns `undefined` while the first query is pending.
 */
export function useHabitLogs(habitIds: string[]): Map<string, HabitLog[]> | undefined {
  return useDataSource().useHabitLogs(habitIds)
}

/** Build the set of completed 'YYYY-MM-DD' keys from a habit's logs. */
export function completedKeySet(logs: HabitLog[] | undefined): Set<string> {
  const set = new Set<string>()
  if (!logs) return set
  for (const log of logs) {
    if (log.completed) set.add(log.date)
  }
  return set
}
